export const signalingColumns = [
    { key: 'accountName', label: 'Account' },
    { key: 'ts', label: 'Date' },
    { key: 'subscriberAlias', label: 'Subscriber Alias' },
    { key: 'vlr', label: 'VLR' },
    { key: 'eid', label: 'EID' },
    { key: 'imsi', label: 'IMSI' },
    { key: 'msisdn', label: 'MSISDN' },
    { key: 'actionType', label: 'Action' },
    { key: 'sccp', label: 'SCCP' },
    { key: 'routingNumber', label: 'Routing Number' },
    { key: 'calledId', label: 'Called' },
    { key: 'reason', label: 'Reason' },
    { key: 'pdpIp', label: 'PDP IP' },
    { key: 'coreNetwork', label: 'Core Network Name' },
    { key: 'upLink', label: 'Up Link' },
    { key: 'downLink', label: 'Down Link' },
    { key: 'dcnr', label: 'DCNR' },
    { key: 'accessPointName', label: 'Access Point Name' },
    { key: 'direction', label: 'Direction' },
    { key: 'code', label: 'Code' },
    { key: 'node', label: 'Node' },
    { key: 'sgsn', label: 'SGSN' },
    { key: 'nsapi', label: 'NSAPI' },
    { key: 'chargeId', label: 'Charge ID' },
    { key: 'cd', label: 'CD' },
    { key: 'iccid', label: 'ICCID' },
    { key: 'id', label: 'ID' },
    { key: 'imei', label: 'IMEI' },
    { key: 'radioAccessType', label: 'Radio Access Type' },
    { key: 'diagnostic', label: 'Diagnostic' },
    { key: 'mme', label: 'MME' },
    { key: 'mccMnc', label: 'MCC/MNC' },
    { key: 'statusType', label: 'Status Type' },
    { key: 'data', label: 'Data' },
    { key: 'upfu', label: 'UPFU' },
    { key: 'upfc', label: 'UPFC' },
    { key: 'resultDescription', label: 'Result Description' },
];
